import MessageClient from "./MessageClient";
import Helpers from "../../commons/helpers";

import { Constants } from "../../constants/constants";
import { IPagedList, IMessageTemplateCase } from "../../commons/interfaces";

export type IRequestUpdateMessageTemplateCase = {
    templateCode: string;
    caseCode: string;
    organizationId: string;
    serviceCode: string;
    tenantCode: string;
    id: string;
};

export type IRequestCreateMessageTemplateCase = Omit<IRequestUpdateMessageTemplateCase, "id">;

export type IRequestGetPagedMessageTemplateCase = {
    templateCode?: string;
    tenantCode?: string;
    serviceCode?: string;
    searchText?: string;
    caseCode?: string;
    orderby?: string;
    pageSize: number;
    pageNumber: number;
    totalCount?: number;
};

const MessageTemplateCaseService = {
    getPaged: async (data: IRequestGetPagedMessageTemplateCase): Promise<IPagedList<IMessageTemplateCase>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await MessageClient().get(`${Constants.ApiPath.MESSAGE_TEMPLATE_CASE.GET_PAGED}?${query}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<IMessageTemplateCase> => {
        const result = await MessageClient().get(`${Constants.ApiPath.MESSAGE_TEMPLATE_CASE.DETAIL}/${id}`);
        return result.data.result;
    },

    create: async (data: IRequestCreateMessageTemplateCase) => {
        const result = await MessageClient().post(Constants.ApiPath.MESSAGE_TEMPLATE_CASE.CREATE, data);
        return result.data.result;
    },

    update: async (data: IRequestUpdateMessageTemplateCase) => {
        const result = await MessageClient().post(Constants.ApiPath.MESSAGE_TEMPLATE_CASE.UPDATE, data);
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(`${Constants.ApiPath.MESSAGE_TEMPLATE_CASE.DELETE}/${id}`);
        return result.data.result;
    },
};

export default MessageTemplateCaseService;
